import { useState } from "react";
import Test from "./Test";
import Packages from "./Packages";
import { useDispatch, useSelector } from "react-redux";
import { clearCurrentPage } from "../../NetworkPortal/ProviderProfileDetails/helper";
import { useParams } from "react-router-dom";

const TestPackages = () => {
  const urlParams = useParams();
  localStorage.setItem("campaignsToken", urlParams?.token);
  const dispatch = useDispatch();
  const [selectTestPackages, setSelectTestPackages] = useState("Test");
  const viewStatusButton = useSelector(
    (state) => state?.globalReducer?.viewStatusButton
  );

  return (
    <div className="right-section p-3">
      <div className="card staff-details-section">
        <div className="card-body">
          <div className="staff-details-header d-flex justify-content-between align-items-center edit-save-css">
            <div>
              <h4>
                {selectTestPackages === "Test"
                  ? "Test Details"
                  : "Package Details"}
              </h4>
            </div>
          </div>
          <div className="___parent_container">
            <div
              className="profile-verification-section"
              style={{ padding: "0px" }}
            >
              <div className="row">
                <div className="col-lg-3 col-md-3 select-test">
                  <select
                    value={selectTestPackages}
                    onChange={(e) => {
                      setSelectTestPackages(e?.target?.value);
                      clearCurrentPage(dispatch);
                    }}
                  >
                    <option value="Test">Test</option>
                    <option value="Package">Package</option>
                  </select>
                </div>
              </div>
              {selectTestPackages === "Test" ? <Test /> : <Packages />}
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="viewstatusModal"
        tabIndex="-1"
        aria-labelledby="viewstatusModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content modal-content-status">
            <div className="modal-body">
              <div className="d-flex justify-content-between align-items-center">
                <h4
                  className={`font-bold text-black mb-0 modal-status-h4 ${
                    viewStatusButton?.ticketStatus?.requestStatus === "Rejected"
                      ? "reject-color"
                      : viewStatusButton?.ticketStatus?.requestStatus ===
                        "Approved"
                      ? "approve-color"
                      : "pending-color"
                  }`}
                >
                  {viewStatusButton?.ticketStatus?.requestStatus}
                </h4>
                <button
                  type="button"
                  className="btn-close history-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <hr />
              <div className="__viewStatus">
                <p style={{ color: "black" }}>
                  <strong>Remark: </strong>
                  {viewStatusButton?.ticketStatus?.remarks}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestPackages;
